var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customModal"},[_c('div',{staticClass:"custom-modal-content"},[_c('button',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Lukk")]),_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }